import request from "@/utils/request";

export function list(data) {
  return request({
    url: "/student/study/ztxm/list",
    method: "post",
    data,
  });
}

export function progresssave(data) {
  return request({
    url: "/student/study/progress/save",
    method: "post",
    data,
  });
}

export function courselist(data) {
  return request({
    url: "/student/study/recommend/course/list",
    method: "post",
    data,
  });
}
